module.exports = __webpack_public_path__ + "static/media/5.0393fd0f.JPG";